module.exports = __webpack_public_path__ + "img/imageUpload.6b5292d9.svg";